import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20l-20 1.74L0 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M2.676 30C6.134 35.978 12.597 40 20 40c7.402 0 13.865-4.022 17.324-10L20 28.696 2.676 30Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M37.324 30A19.908 19.908 0 0 0 40 20H0c0 3.643.974 7.058 2.676 10h34.648Z"
}, null, -1), i = [
  n,
  c,
  s
];
function d(r, _) {
  return e(), o("svg", l, [...i]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
